import { RouteRecordRaw } from 'vue-router'

const openApiRouter: Array<RouteRecordRaw> = [
    {
        path: '/open_api',
        name: '接口文档首页',
        component: () => import('@/views/openApi/Index.vue')
    }
]
export default openApiRouter